import Splide from "@splidejs/splide"
window.Splide = Splide


import { createInteriorCarousel } from './interior-carousel'
document.addEventListener('DOMContentLoaded', createInteriorCarousel(window.LazyLoad, window.lazyLoadInstance));
